/* Wuffy Lab — logique offre (lignes des cartes Format, pré-sélection 2 pots,
   pot Hygiène Dentaire offert avec 3 pots jusqu'au 31/10, bump & mix panier).
   Chargé par sections/wl-announcement.liquid (groupe header = toutes les pages).
   Les remises elles-mêmes sont des réductions automatiques Shopify :
   « Offre de lancement : pot Hygiène Dentaire offert » (fin 31/10/2026), « Hygiène Dentaire à 14,90 € », « 2e formule −25 % ».
   Si une remise est modifiée dans l'admin, mettre à jour OFFER ci-dessous.
   v11 (2026-09-13): libellés courts pour les cartes en mode compact
   (formulaire .wl-buy-compact, voir wl-pdp.js) + ligne impulsion / mini timer
   sur le cut-off d'expédition (OFFER.impulse). Logique panier inchangée. */
(function () {
  "use strict";
  if (window.__wlOfferInit) return;
  window.__wlOfferInit = true;

  var OFFER = {
    giftUntil: "2026-10-31",
    formulas: ["wuffylab-immunite-demangeaisons", "peau-pelage", "articulations-mobilite", "calme-serenite", "hygiene-dentaire"],
    bumpBuyers: ["wuffylab-immunite-demangeaisons", "peau-pelage", "articulations-mobilite", "calme-serenite"],
    dentaireHandle: "hygiene-dentaire",
    giftBySize: { "Moins de 10 kg": 54807839441233, "10 - 25 kg": 54807839539537, "Plus de 25 kg": 54807839637841 },
    giftDefault: 54807839539537,
    bumpPrice: 1490, /* v12 (2026-09-14) : prix bas, bump aligné (remise auto −15 €) */
    mixPct: 25,
    cardLines: {
      1: "+ 4,90 € de livraison · offerte dès 49 €",
      2: "Livraison offerte",
      3: "Livraison offerte + 1 pot Hygiène Dentaire offert",
      "3dentaire": "Livraison offerte + 4e pot offert",
      "3after": "Livraison offerte"
    },
    /* Mode compact : une ligne courte, jamais à la ligne à 375 px (colonne texte ≈ 166 px).
       « Livraison + pot Dentaire offerts » dépassait → forme courte. */
    cardLinesCompact: {
      1: "Livraison 4,90 €",
      2: "Livraison offerte",
      3: "+ pot Dentaire offert",
      "3dentaire": "+ 4e pot offert",
      "3after": "Livraison offerte"
    },
    popular: "2 pots",
    /* Ligne impulsion + mini timer (mode compact seulement). Cut-off logistique réel :
       heure de Paris, jours ouvrés. Après l'heure ou le week-end : phrase sans timer.
       Pour changer l'heure de cut-off : cutoffHour / cutoffMinute. */
    impulse: {
      cutoffHour: 14,
      cutoffMinute: 0,
      workdays: [1, 2, 3, 4, 5],
      lead: "Plus tôt il commence, plus tôt vous saurez.",
      before: "Commandé avant {h} h, expédié aujourd’hui",
      afterWeekday: "Commandez maintenant : expédié demain matin",
      afterFriday: "Commandez maintenant : expédié lundi matin"
    },
    labels: {
      gift: "Offert",
      giftMeta: "Offre de lancement · offert avec votre cure de 3 pots",
      bumpTag: "Prix panier · −15 €",
      mixTag: "2e formule · −25 %"
    }
  };

  var today = function () {
      var d = new Date();
      return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    },
    giftActive = function () { return today() <= OFFER.giftUntil; },
    ready = function (fn) {
      document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn);
    },
    money = function (c) { return (c / 100).toFixed(2).replace(".", ",") + " €"; },
    optVal = function (item, name) {
      var o = (item.options_with_values || []).filter(function (x) { return x.name === name; })[0];
      return o ? o.value : "";
    },
    isGift = function (i) { return !!(i.properties && i.properties._wl_gift); },
    isCompactForm = function (form) {
      if (form.classList.contains("wl-buy-compact")) return true;
      try {
        var sl = document.querySelector("[data-wl-labels]");
        var pl = sl ? JSON.parse(sl.textContent) || {} : {};
        return /\{months\}/.test(pl.sub || "");
      } catch (e) { return false; }
    };

  /* ---------- PDP : ligne impulsion + mini timer sur le cut-off d'expédition ---------- */
  var parisNow = function () {
      try { return new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" })); }
      catch (e) { return new Date(); }
    },
    initImpulse = function (form) {
      if (form.querySelector("[data-wl-impulse]")) return;
      var I = OFFER.impulse,
        firstCard = form.querySelector("[data-wl-cure-card]"),
        host = firstCard ? firstCard.parentNode : null;
      if (!host) return;
      var row = document.createElement("div");
      row.setAttribute("data-wl-impulse", "");
      row.className = "wl-buy-impulse";
      row.innerHTML =
        '<span class="wl-buy-impulse__bolt" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"/></svg></span>' +
        '<span class="wl-buy-impulse__txt"><span data-wl-impulse-lead></span> <b data-wl-impulse-msg></b></span>' +
        '<span class="wl-buy-impulse__timer" data-wl-impulse-timer hidden></span>';
      /* après la ligne de livraison de wl-pdp.js si elle existe déjà, sinon après les cartes */
      var after = host.nextSibling && host.nextSibling.hasAttribute && host.nextSibling.hasAttribute("data-wl-deliver-line") ? host.nextSibling : host;
      after.parentNode.insertBefore(row, after.nextSibling);
      var lead = row.querySelector("[data-wl-impulse-lead]"),
        msg = row.querySelector("[data-wl-impulse-msg]"),
        timer = row.querySelector("[data-wl-impulse-timer]");
      lead.textContent = I.lead;
      var tick = function () {
        var p = parisNow(), day = p.getDay(),
          cut = new Date(p); cut.setHours(I.cutoffHour, I.cutoffMinute, 0, 0);
        var d = cut - p, workday = I.workdays.indexOf(day) !== -1;
        if (workday && d > 0) {
          msg.textContent = I.before.replace("{h}", String(I.cutoffHour));
          var h = Math.floor(d / 36e5), m = Math.floor((d % 36e5) / 6e4);
          timer.textContent = (h ? h + " h " : "") + (m < 10 ? "0" : "") + m + " min";
          timer.hidden = false;
        } else {
          msg.textContent = (day === 5 && d <= 0) || day === 6 || day === 0 ? I.afterFriday : I.afterWeekday;
          timer.hidden = true;
        }
      };
      tick();
      setInterval(tick, 30000);
    };

  /* ---------- PDP : ligne d'offre par carte + pré-sélection ---------- */
  var initPdp = function () {
    var form = document.querySelector("[data-wl-product-form]");
    if (!form) return;
    var isDentaire = location.pathname.indexOf("/products/" + OFFER.dentaireHandle) !== -1,
      compact = isCompactForm(form),
      L = compact ? OFFER.cardLinesCompact : OFFER.cardLines;

    form.querySelectorAll("[data-wl-cure-card]").forEach(function (card) {
      var input = card.querySelector("input[data-wl-pots]");
      if (!input || card.querySelector("[data-wl-offer-line]")) return;
      var pots = Number(input.getAttribute("data-wl-pots")),
        text = L[pots];
      if (pots === 3) text = giftActive() ? (isDentaire ? L["3dentaire"] : L[3]) : L["3after"];
      if (!text) return;
      var sub = card.querySelector("[data-wl-sub-for]"),
        host = sub ? sub.parentNode : card,
        line = document.createElement("span");
      line.setAttribute("data-wl-offer-line", String(pots));
      line.textContent = text;
      line.style.cssText = "font-size:12px;font-weight:700;line-height:1.35;color:" + (pots === 1 ? "var(--wl-forest-600)" : "#4F7A2A");
      host.appendChild(line);
    });

    if (compact) initImpulse(form);

    /* format mis en avant présélectionné, sauf si ?variant= dans l'URL */
    if (!/[?&]variant=/.test(location.search)) {
      var pick = function () {
        var target = Array.prototype.filter.call(
          form.querySelectorAll('[data-wl-opt="1"] input[type="radio"]'),
          function (i) { return i.value === OFFER.popular; }
        )[0];
        if (target && !target.checked) { target.checked = true; target.dispatchEvent(new Event("change", { bubbles: true })); }
      };
      document.readyState === "complete" ? setTimeout(pick, 60) : window.addEventListener("load", function () { setTimeout(pick, 60); });
    }
  };

  /* ---------- Panier : pot offert, bump Dentaire, mix 2e formule ---------- */
  var busy = false, lastSig = "",
    post = function (path, body) {
      return fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    refreshDrawer = function () {
      return window.wlCart && window.wlCart.refresh ? window.wlCart.refresh() : Promise.resolve();
    },
    reconcile = function (cart) {
      var items = cart.items || [],
        gifts = items.filter(isGift),
        giftLine = gifts[0],
        qualifying = items.filter(function (i) {
          return !isGift(i) && OFFER.formulas.indexOf(i.handle) !== -1 && optVal(i, "Format") === "3 pots";
        }),
        paidDentaire1 = items.filter(function (i) {
          return !isGift(i) && i.handle === OFFER.dentaireHandle && optVal(i, "Format") === "1 pot";
        }),
        wantGift = giftActive() && qualifying.length > 0 && paidDentaire1.length === 0;
      if (gifts.length > 1) return post("/cart/change.js", { id: gifts[1].key, quantity: 0 });
      if (giftLine && !wantGift) return post("/cart/change.js", { id: giftLine.key, quantity: 0 });
      if (giftLine && giftLine.quantity > 1) return post("/cart/change.js", { id: giftLine.key, quantity: 1 });
      if (!giftLine && wantGift) {
        var size = optVal(qualifying[0], "Taille du chien"),
          vid = OFFER.giftBySize[size] || OFFER.giftDefault;
        return post("/cart/add.js", { items: [{ id: vid, quantity: 1, properties: { _wl_gift: "1" } }] });
      }
      return null;
    },
    decorate = function (cart) {
      var root = document.querySelector("[data-wl-cart]");
      if (!root) return;
      var items = cart.items || [];
      items.forEach(function (i) {
        if (!isGift(i)) return;
        var line = root.querySelector('[data-wl-line="' + (window.CSS && CSS.escape ? CSS.escape(i.key) : i.key) + '"]');
        if (!line || line.getAttribute("data-wl-gift-done")) return;
        line.setAttribute("data-wl-gift-done", "1");
        var price = line.querySelector(".wl-cart__price");
        if (price && i.final_line_price === 0) {
          price.innerHTML = "<span>" + OFFER.labels.gift + '</span><span class="wl-cart__was">' + money(i.original_line_price) + "</span>";
        }
        var ctrl = line.querySelector(".wl-cart__ctrl");
        if (ctrl) ctrl.style.display = "none";
        var info = line.querySelector(".wl-cart__info");
        if (info) {
          var m = document.createElement("span");
          m.className = "wl-cart__plan";
          m.textContent = OFFER.labels.giftMeta;
          info.appendChild(m);
        }
      });
      var paid = items.filter(function (i) { return !isGift(i); }),
        hasDentaire1 = paid.some(function (i) { return i.handle === OFFER.dentaireHandle && optVal(i, "Format") === "1 pot"; }),
        bumpOk = !hasDentaire1 && paid.some(function (i) {
          return OFFER.bumpBuyers.indexOf(i.handle) !== -1 && (optVal(i, "Format") === "1 pot" || optVal(i, "Format") === "2 pots");
        }),
        formulaUnits = paid.filter(function (i) { return OFFER.formulas.indexOf(i.handle) !== -1; })
          .reduce(function (n, i) { return n + i.quantity; }, 0),
        mixOk = formulaUnits === 1;
      root.querySelectorAll("[data-wl-up]").forEach(function (up) {
        if (up.getAttribute("data-wl-up-done")) return;
        var handle = up.getAttribute("data-wl-up"),
          priceEl = up.querySelector(".wl-cart__up-price");
        if (!priceEl) return;
        var base = Math.round(parseFloat(String(priceEl.firstChild && priceEl.firstChild.textContent || priceEl.textContent).replace(/[^\d,.-]/g, "").replace(",", ".")) * 100);
        if (!base) return;
        var newPrice = 0, tag = "";
        if (handle === OFFER.dentaireHandle && bumpOk) { newPrice = OFFER.bumpPrice; tag = OFFER.labels.bumpTag; }
        else if (OFFER.formulas.indexOf(handle) !== -1 && mixOk) { newPrice = Math.round(base * (100 - OFFER.mixPct) / 100); tag = OFFER.labels.mixTag; }
        if (!newPrice || newPrice >= base) return;
        up.setAttribute("data-wl-up-done", "1");
        priceEl.innerHTML = money(newPrice) + "<s>" + money(base) + "</s>";
        var t = up.querySelector(".wl-cart__up-tag");
        if (t) t.textContent = tag;
        else {
          var info = up.querySelector(".wl-cart__up-info");
          if (info) {
            var s = document.createElement("span");
            s.className = "wl-cart__up-tag";
            s.textContent = tag;
            info.insertBefore(s, info.firstChild);
          }
        }
      });
    },
    run = function () {
      if (busy) return;
      busy = true;
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sig = (cart.items || []).map(function (i) { return i.key + ":" + i.quantity + ":" + i.final_line_price; }).join("|"),
            action = reconcile(cart);
          if (action) return action.then(function () { lastSig = ""; busy = false; return refreshDrawer(); });
          decorate(cart);
          lastSig = sig;
          busy = false;
        })
        .catch(function () { busy = false; });
    },
    initCart = function () {
      var list = document.querySelector("[data-wl-cart-items]");
      if (!list || !window.MutationObserver) return;
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); }).observe(list, { childList: true });
      var ups = document.querySelector("[data-wl-cart-upsell-list]");
      if (ups) new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); }).observe(ups, { childList: true });
    };

  ready(function () { initPdp(); initCart(); });
})();
